// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__G4dwQ","content":"home_content__AAG3i","intro":"home_intro__xc9x+"};